import React, { useState } from "react";
import {
  Container,
  HeaderWrapper,
  IconsWrapper,
  Navbar,
  NavTitle,
  NavWrapper,
  Overlay,
  // SearchIconWrapper,
  SocialLinkItem,
  SocialLinkLabel,
  SocialLinksWrapper,
  StyledExternalLink,
  StyledHamburger,
  StyledIcon,
  StyledIconLink,
  StyledLi,
  StyledLink,
  StyledLogo,
  StyledText,
  StyledUl,
} from "./styles";
import useLockedBody from "utils/useLockedBody";
import { SidebarData, socialLinks } from "./sidebarData";
import { StaticQuery, graphql } from "gatsby";
import Search from "./search";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenSearch, setIsOpenSearch] = useState(false);

  const [locked, setLocked] = useLockedBody();

  // const handleClickSearchIcon = () => {
  //   setIsOpenSearch((prev) => !prev);
  // };

  const handleClickOutside = () => {
    if (isOpen) {
      setLocked(false);
      setIsOpen(false);
    }
  };

  const handleClickHamburger = () => {
    locked ? setLocked(false) : setLocked(true);
    setIsOpen((prev) => !prev);
  };

  const renderLink = (item) => {
    let child = item.title;

    if (item.iconType)
      child = <StyledIcon type={item.iconType} width={item.width} />;
    if (!item?.path) return <StyledText>{child}</StyledText>;
    return /^\/(?!\/)/.test(item.path) ? (
      <StyledLink to={item.path}>{child}</StyledLink>
    ) : (
      <StyledExternalLink target={item.target ?? "_self"} href={item.path}>
        {child}
      </StyledExternalLink>
    );
  };

  const handleBlurInput = () => {
    isOpenSearch && setTimeout(setIsOpenSearch, 200, false);
  };

  return (
    <Container>
      <HeaderWrapper>
        <StyledHamburger
          size={25}
          toggled={isOpen}
          toggle={handleClickHamburger}
          color="#696057"
          direction="left"
        />
        <StyledIconLink href={"/"}>
          <StyledLogo type={"Logo"} />
        </StyledIconLink>

        <IconsWrapper>
          {isOpenSearch && (
            <StaticQuery
              query={graphql`
                query SearchIndexQuery {
                  siteSearchIndex {
                    index
                  }
                }
              `}
              render={(data) => (
                <Search
                  onBlurInput={handleBlurInput}
                  searchIndex={data.siteSearchIndex.index}
                />
              )}
            />
          )}

          {/*<SearchIconWrapper onClick={handleClickSearchIcon}>
            <StyledIcon type={"Search"} />
          </SearchIconWrapper>*/}
          <StyledIconLink href={"https://community.savant.com/Customers"}>
            <StyledIcon type={"User"} />
          </StyledIconLink>
        </IconsWrapper>
      </HeaderWrapper>

      <Overlay isOpen={isOpen} onClick={handleClickOutside} />
      <Navbar isOpen={isOpen}>
        {SidebarData.map((item, index) =>
          !item.links.length ? (
            <NavWrapper key={"wrapper" + index}>
              <NavTitle>{renderLink(item)}</NavTitle>
            </NavWrapper>
          ) : (
            <NavWrapper key={"wrapper" + index}>
              <NavTitle>{renderLink(item)}</NavTitle>
              <StyledUl>
                {item.links.map((link, i) => (
                  <StyledLi key={link.title + i}>{renderLink(link)}</StyledLi>
                ))}
              </StyledUl>
            </NavWrapper>
          )
        )}
        <SocialLinksWrapper>
          {socialLinks.map((item, index) => (
            <SocialLinkItem key={item.link + index}>
              <StyledExternalLink href={item.link} target="_blank">
                <StyledIcon type={item.iconType} />
                <SocialLinkLabel>{item.title}</SocialLinkLabel>
              </StyledExternalLink>
            </SocialLinkItem>
          ))}
        </SocialLinksWrapper>
      </Navbar>
    </Container>
  );
};

export default Header;
